import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";
import { useEffect, useRef } from "react";
import { useAppSelector } from "store/hooks";

type TextAndTemplateFieldProps = {
  name: string;
  value: string;
  onChange: (event: any) => void;
  label: "Text" | "Template";
};

const TextAndTemplateField = (props: TextAndTemplateFieldProps) => {
  const inputRef = useRef<HTMLElement | null>(null);

  const selectedRoute = useAppSelector(
    (state) => state.developer.edit.editor.selectedRoute
  );

  useEffect(() => {
    if (selectedRoute) {
      inputRef.current && inputRef.current.focus();
    }
  }, [selectedRoute]);

  return (
    <EditorVisualTextField
      label={props.label}
      size="small"
      fullWidth
      multiline={true}
      minRows={1}
      maxRows={4}
      inputRef={inputRef}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      // This is a fix for multiline bug that set cursor to start of input even if has value
      onFocus={(e) => {
        e.target.setSelectionRange(
          e.target.value.length,
          e.target.value.length
        );
      }}
    />
  );
};

export default TextAndTemplateField;
